import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  /**
   * `__BUILD_VERSION__` becomes the build's version (scripts/cache-bust.js),
   * so a deploy's translations are fetched again, not served from the cache.
   */
  getTranslation(lang: string) {
    return this.http.get<Translation>(
      `./assets/i18n/${lang}.json?v=__BUILD_VERSION__`
    );
  }
}
